import { COUPON_CALLOUTS_BACKEND_URL } from './src-constants-api.constants.js';

const fetchCouponDetails = async (request) => {
  const url = `${COUPON_CALLOUTS_BACKEND_URL}/tenant/${request.tenant}/locale/${request.locale}/coupon-price?requestor=${request.requestor}&pageId=${request.pageId}`;
  const { tenant, locale, pageId, requestor, ...body } = request;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(body)
  });
  const responseData = await response.json();
  if (!response.ok) {
    const errorPayload = { ...responseData, status: response.status };
    throw new Error(JSON.stringify(errorPayload));
  }
  return responseData;
};

export { fetchCouponDetails };
//# sourceMappingURL=src-clients-couponCallout.client.js.map
